import React from 'react';
import { Box, Typography } from '@mui/material';

interface SubTitleProps {
  title: string | boolean;
}

function SubTitle({ title }: SubTitleProps): JSX.Element {
  return (
    <Box className="flex mb-6 max-md:mb-5 items-center">
      <Typography variant="subtitle1" className="pl-4 border-l-2 border-rf-black text-lg text-black font-bold">
        {title}
      </Typography>
    </Box>
  );
}

export default SubTitle;
